import React from 'react';

import { ModalKeys } from '../../context/modals';
import ModalText from './text-modal';

function ModalPaymentUnavailable() {
  return (
    <ModalText type={ModalKeys.PaymentUnavailable}>
      <div className="text-center py-4">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>
        <p className="text-gray-700 text-lg mb-2">Payment service is temporarily unavailable.</p>
        <p className="text-gray-500">
          Please try again in a few minutes or contact us at{' '}
          <a href="mailto:hello@self.co" className="text-primary underline">
            hello@self.co
          </a>{' '}
          if the issue persists.
        </p>
      </div>
    </ModalText>
  );
}

export default ModalPaymentUnavailable;
